import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../utils/bongo';
import type { ModuleId } from '../../types';

export type TenantRbacUserAssignment = {
  user_id: string;
  role: 'orgAdmin' | 'standard';
  assigned_modules: ModuleId[];
  seat_status: 'active' | 'inactive' | 'invited';
};

export type TenantRbacDoc = {
  _id: string;
  tenant_id: number;
  status: 'pending' | 'active';
  tier: 'starter' | 'growth' | 'enterprise';
  purchased_modules: ModuleId[];
  seats: { total: number; used: number };
  user_assignments: TenantRbacUserAssignment[];
};

/**
 * Read the tenant's RBAC doc from Bongo. Mirrors mk-admin-app's
 * `useTenantRbacDoc` so superKudu admins (whose own JWT doesn't carry
 * `rbac`) can still see the tenant's tier/purchased modules.
 *
 * Query key matches mk-admin-app exactly in case persisted caches ever
 * get shared via subdomain rehydration.
 */
export function useTenantRbacDoc(tenantId: string | undefined | null) {
  return useQuery<TenantRbacDoc>({
    queryKey: ['tenant-rbac', tenantId],
    queryFn: async () => {
      const { data } = await axios.get<TenantRbacDoc>(
        `${getBongoUrl()}/v1/org/${tenantId}/rbac`
      );
      return data;
    },
    enabled: !!tenantId,
  });
}
